module.exports = __webpack_public_path__ + "assets/icon_documents.3031164e.svg";